/* ---------------------------------------------------------------------------
   Canonical defaults for CMS-managed sections whose data is small enough to
   live here (larger ones — facilities — are exported from their component).
   Both the public component (as useSection fallback) and the admin (to show the
   current values in the editor) read from these, so there is a single source of
   truth and no risk of the two drifting apart.
--------------------------------------------------------------------------- */

/* The headline stats band on the home page. `end` counts up. */
export const HOME_STATS = [
  { end: 200, suffix: "+", label: "Companies for placements" },
  { end: 20, prefix: "₹", suffix: " Lakh", label: "Highest package offered" },
  { end: 50, suffix: "+", label: "International collaborations" },
  { end: 10000, suffix: "+", label: "Alumni worldwide" },
];
